import { render, staticRenderFns } from "./login-code.vue?vue&type=template&id=2436a6b2&scoped=true"
import script from "./login-code.vue?vue&type=script&lang=js"
export * from "./login-code.vue?vue&type=script&lang=js"
import style0 from "./login-code.vue?vue&type=style&index=0&id=2436a6b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436a6b2",
  null
  
)

export default component.exports